import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgHome = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M4.31367 9.7191C4 10.4011 4 11.1769 4 12.7287V17.5748C4 19.7298 4 20.8073 4.66947 21.4768C5.29301 22.1003 6.2705 22.1431 8.14286 22.146V16.432C8.14286 15.2486 9.10225 14.2892 10.2857 14.2892H13.7143C14.8978 14.2892 15.8571 15.2486 15.8571 16.432V22.146C17.7295 22.1431 18.707 22.1003 19.3305 21.4768C20 20.8073 20 19.7298 20 17.5748V12.7287C20 11.1769 20 10.4011 19.6863 9.7191C19.3727 9.03711 18.7836 8.53218 17.6054 7.52234L16.4626 6.54274C14.3331 4.71745 13.2683 3.80481 12 3.80481C10.7317 3.80481 9.66694 4.71745 7.53743 6.54275L6.39457 7.52234C5.21642 8.53218 4.62734 9.03711 4.31367 9.7191ZM13.8571 22.1463V16.432C13.8571 16.3531 13.7932 16.2892 13.7143 16.2892H10.2857C10.2068 16.2892 10.1429 16.3531 10.1429 16.432V22.1463H13.8571Z",
		fill: "currentColor"
	})
});
export default SvgHome;
